import React, { useContext } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { Carousel } from 'antd';
import { IStudyToolResult } from '@/types';
import { bindEvents } from '@/utils/sensors-data';
import SensorsDataContext from '@/components/home/context';

interface IProps {
    dataSource: IStudyToolResult['slideShows'];
}

const Banner = (props: IProps) => {
    const sensorsDataContextValues = useContext(SensorsDataContext);

    const handleClick = (data: IStudyToolResult['slideShows'][number]) => {
        bindEvents('pc_studytab_banner_click', {
            ...sensorsDataContextValues,
            activity_name: data.bannerName,
            activity_id: data.bannerId,
        });

        if (data.jumpLink) {
            window.open(data.jumpLink, '_blank');
        }
    };

    return (
        <Carousel autoplay className={styles.banner}>
            {props.dataSource.map(item => (
                <div
                    className={classNames(styles['banner-item'], {
                        [styles['pointer']]: !!item.jumpLink,
                    })}
                    key={item.bannerId}
                    onClick={() => handleClick(item)}
                >
                    <img src={item.picSrc} alt="" />
                </div>
            ))}
        </Carousel>
    );
};

export default Banner;
